import contextMethods from './contextMethods';

/**
 * The AttributeValueParsers are intended to
 * parse some attibutes depending on their values
 * instead of their names.
 */
const AttributeValueParsers = (currentValue: unknown) => {
  if (currentValue === 'true') return true;
  if (currentValue === 'false') return false;

  if (typeof currentValue === 'string') {
    const result = currentValue.match(/^__contextMethod\.(\w+)\.(\w+)$/);
    if (result) {
      return contextMethods[result[1]][result[2]];
    }
  }
  return currentValue;
};

export default AttributeValueParsers;
